import { ApolloProvider } from '@apollo/client'
import { Provider as DesignProvider } from '@weareberyl/design-system'
import { Component } from 'react'
import { AppRegistry } from 'react-native'
import { Router } from 'react-router-dom'
import { StripeProvider } from 'react-stripe-elements'
import './index.less'

import client from '~/client'
import history from '~/client/history'
import App from '~/components/App'
import HeadTitle from '~/components/HeadTitle'
import { ErrorBoundary } from '~/components/Query/utils'
import SessionManager from '~/components/Session/manager'
import AutomationProvider from '~/context/automationContext'
import CommissionDetailsProvider from '~/context/commissionDetails'
import ConfigProvider from '~/context/configContext'
import CurrentSchemeProvider from '~/context/currentScheme'
import CurrentUserProvider from '~/context/currentUser'
import DevicesProvider from '~/context/devices'
import FeatureFlagsProvider from '~/context/featureFlags'

import config from '~/constants/config'

class Root extends Component {
  render() {
    return (
      // skipcq JS-0415
      <ErrorBoundary>
        <DevicesProvider>
          <ApolloProvider client={client}>
            <CurrentUserProvider>
              <SessionManager>
                <CurrentSchemeProvider>
                  <FeatureFlagsProvider>
                    <CommissionDetailsProvider>
                      <StripeProvider apiKey={config.STRIPE_API_KEY}>
                        <Router history={history}>
                          <DesignProvider>
                            <ConfigProvider>
                              <AutomationProvider>
                                <App />
                              </AutomationProvider>
                            </ConfigProvider>
                          </DesignProvider>
                          <HeadTitle />
                        </Router>
                      </StripeProvider>
                    </CommissionDetailsProvider>
                  </FeatureFlagsProvider>
                </CurrentSchemeProvider>
              </SessionManager>
            </CurrentUserProvider>
          </ApolloProvider>
        </DevicesProvider>
      </ErrorBoundary>
    )
  }
}

const nativeRoot = document.getElementById('root')
if (nativeRoot) {
  AppRegistry.registerComponent('App', () => Root)
  AppRegistry.runApplication('App', {
    initialProps: {},
    rootTag: nativeRoot,
  })
}
